import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BOM_OWNER_DASHBOARD_STAT } from "./apiRoutes";

interface UseGetExpenseChartDataProps {
  year: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getExpenseChartData = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${BOM_OWNER_DASHBOARD_STAT(communityId)}/expense-chart?budgetYear=${year}`
  );

const useGetExpenseChartData = ({
  year,
  communityId,
  queryParams,
}: UseGetExpenseChartDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-expense-chart-data", communityId, year],
    queryFn: () => getExpenseChartData(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: queryParams?.enabled,
  });
};

export default useGetExpenseChartData;
